import { Container } from '@material-ui/core';
import AuthorizedContent from 'components/authorized-content';
import BackToAnywhere from 'pages/shared/back-to-anywhere';
import { UserRole } from 'providers/user/user-role.enum';
import React from 'react';
import { useCurrentRoute, useNavigation } from 'react-navi';
import './flock-profiles.scss';

type FlockProfileWrapperProps = {
  title: string;
  children: React.ReactNode;
  backLocationName?: string;
  backRoute?: string;
  backRouteState?: Record<string, unknown>;
  roles?: UserRole[];
};

type FlockProfileRouteData = {
  returnTo?: string;
};

const fallbackReturnTo = '/producer/my-company/tools';

const decodeReturnTo = (returnTo: string): string | undefined => {
  try {
    return decodeURIComponent(returnTo);
  } catch {
    return undefined;
  }
};

const getSafeReturnTo = (returnTo: string | undefined): string => {
  if (!returnTo) {
    return fallbackReturnTo;
  }

  const decodedReturnTo = decodeReturnTo(returnTo);

  if (
    !decodedReturnTo
    || !decodedReturnTo.startsWith('/')
    || decodedReturnTo.startsWith('//')
    || decodedReturnTo.includes('://')
  ) {
    return fallbackReturnTo;
  }

  return decodedReturnTo;
};

const getBackLocationName = (route: string): string => {
  if (route.startsWith('/search/dashboard') || route.startsWith('/searhc/dashboard')) {
    return 'Dashboard';
  }

  return 'Company';
};

export const FlockProfileWrapper: React.FC<FlockProfileWrapperProps> = ({
  title,
  children,
  backLocationName,
  backRoute,
  backRouteState,
  roles = [UserRole.CompanyUser],
}) => {
  const navigation = useNavigation();
  const route = useCurrentRoute();
  const { query } = navigation.getCurrentValue().url;
  const routeData = route.data as FlockProfileRouteData | undefined;
  const returnTo = routeData?.returnTo || (typeof query.returnTo === 'string' ? query.returnTo : undefined);
  const resolvedBackRoute = backRoute || getSafeReturnTo(returnTo);

  return (
    <>
      <BackToAnywhere
        locationName={backLocationName || getBackLocationName(resolvedBackRoute)}
        route={resolvedBackRoute}
        state={backRouteState}
      />
      <AuthorizedContent roles={roles}>
        <div className='sg-flock-profile-report-bar'>
          <Container className='sg-flock-profile-report__container'>
            <h2>{title}</h2>
          </Container>
        </div>
        <br />
        {children}
      </AuthorizedContent>
    </>
  );
};

export default FlockProfileWrapper;
